module.exports = __webpack_public_path__ + "static/media/roomsF.074047e0.png";